import { ExpandMore, Key, Logout } from '@mui/icons-material';
import { ListItemIcon, Menu, MenuItem, Tooltip } from '@mui/material';
import { observer } from 'mobx-react-lite';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { routerUrls } from '@/configs/routes/routerUrls';
import { useUserStore } from '@/configs/store';

import s from './UserProfileMenu.module.scss';

const initialsOf = (name: string) =>
  name
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part[0] ?? '')
    .join('')
    .toUpperCase();

/** Пользователь в шапке: аватар, имя и почта; по клику — меню с «Выйти» */
export const UserProfileMenu: React.FC = observer(() => {
  const navigate = useNavigate();
  const { logout, user, fullName, isAdmin } = useUserStore();
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleLogout = async () => {
    setAnchorEl(null);
    await logout();
    navigate(routerUrls.login, { replace: true });
  };

  if (!user) return null;

  const name = fullName || 'Пользователь';

  return (
    <>
      <button
        type="button"
        className={s.profile}
        aria-haspopup="menu"
        aria-expanded={!!anchorEl}
        aria-controls={anchorEl ? 'profile-menu' : undefined}
        onClick={(event) => setAnchorEl(event.currentTarget)}
      >
        <span className={s.profile__avatar} aria-hidden>
          {initialsOf(name)}
        </span>
        <span className={s.profile__info}>
          <span className={s.profile__name}>
            {name}
            {isAdmin && (
              <Tooltip title="Вы администратор" arrow>
                <Key className={s.profile__admin} aria-label="Администратор" />
              </Tooltip>
            )}
          </span>
          {user.email && <span className={s.profile__email}>{user.email}</span>}
        </span>
        <ExpandMore className={s.profile__chevron} fontSize="small" />
      </button>
      <Menu
        id="profile-menu"
        anchorEl={anchorEl}
        open={!!anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        slotProps={{ paper: { sx: { mt: 0.5, minWidth: 180, borderRadius: '8px' } } }}
      >
        <MenuItem
          onClick={handleLogout}
          sx={{
            fontSize: 14,
            '&:hover': { color: 'var(--danger-color)' },
            '&:hover .MuiListItemIcon-root': { color: 'var(--danger-color)' },
          }}
        >
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          Выйти
        </MenuItem>
      </Menu>
    </>
  );
});
